module.exports = __webpack_public_path__ + "img/KAD.b2ca6f30.png";